import styled from "styled-components/macro";

import logo from "Payments/CreditCardAssets/LargeCardLogos/visa_logo.png";
import logoWhite from "Payments/CreditCardAssets/LargeCardLogos/visa_white.png";
import { motion } from "framer-motion";

import { Shine, iPhone, iPhoneMini } from "../styles";

export default function Visa({ isAlreadyExisting }) {
  return (
    <>
      <Background
        initial={isAlreadyExisting ? {} : { opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.2 } }}
        exit={{ opacity: 0 }}
      />
      <Shine />
      <Logo
        src={logo}
        initial={isAlreadyExisting ? {} : { x: 80, opacity: 0 }}
        animate={{ scale: 1, x: 0, opacity: 1 }}
        exit={{ x: 80, opacity: 0, transition: { type: "tween" } }}
      />
      <FadedLogo
        initial={isAlreadyExisting ? {} : { x: 140, opacity: 0 }}
        animate={{ x: 0, opacity: 0.1 }}
        exit={{ x: 140, opacity: 0, transition: { type: "tween" } }}
      />
    </>
  );
}

const Background = styled(motion.div)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(to bottom left, #21a2cc, #005385);
`;

const FadedLogo = styled(motion.div)`
  position: absolute;
  left: -20px;
  right: -30px;
  bottom: -6px;
  top: 0;
  opacity: 0.1;
  background-image: url(${logoWhite});
  background-size: contain;
  background-position: bottom center;
  background-repeat: no-repeat;
`;
const Logo = styled(motion.img)`
  position: absolute;
  top: 28px;
  right: 40px;
  width: 100px;
  @media screen and (max-width: ${iPhone.cssWidth}) {
    right: 32px;
  }
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    top: auto;
    width: auto;
    height: 24px;
    right: 32px;
    bottom: ${iPhoneMini.logoBottom};
    margin-bottom: -16px;
  }
`;
